// extracted by mini-css-extract-plugin
module.exports = {"brand":"ProductCardLabel_brand__3IPI8","container":"ProductCardLabel_container__8UFYN","label":"ProductCardLabel_label__27JT4"};